import { Button } from "components/button";
import React from "react";
import "./error.css";

interface IError {
  handleReload: () => void;
  imagePath?: string | null;
  header: string;
  subheader?: React.ReactNode | string;
  btnAction: string;
  withButton?: boolean;
}

export const Error: React.FC<IError> = (props: IError) => {
  const { imagePath, header, subheader, btnAction, handleReload, withButton } = props;

  return (
    <div
      className={`row ${withButton ? "d-flex flex-column wrapper-info" : ""}`}
      data-testid="error-container"
    >
      <div>
        {imagePath ? (
          <div className="col-12 text-center" data-testid="error-image-container">
            <img
              src={imagePath}
              className="error-header"
              alt="error logo"
              data-testid="error-image" 
            />
          </div>
        ) : null}
        <div className="col-12 text-center p-2" data-testid="error-header-container"> 
          <h1 className="error-header" data-testid="error-header">{header}</h1> 
          {subheader && <div data-testid="error-subheader">{subheader}</div>} 
        </div>
      </div>
      {withButton ? (
        <Button
          handleClick={() => {
            handleReload();
          }}
          textButton="closeButton"
          isDisabled={false}
          customClassName="submit-button"
          dataTestId="error-button" 
        />
      ) : (
        <div className="col-12 text-center p-3" data-testid="error-link-container"> 
        {/* eslint-disable-next-line */}
          <a onClick={handleReload} data-testid="error-link">{btnAction}</a>
        </div>
      )}
    </div>
  );
};
